export default "__VITE_PUBLIC_ASSET__d6e9a769__"